import { Observable, throwError } from 'rxjs';
import { ErrorAdapter } from '@models/adapter/error.adapter';

/** Error de validación PNR antes del request (sin HTTP). */
export function throwPnrLookupError(msg: string): Observable<never> {
  return throwError(() => ErrorAdapter.adapt({ code: msg, msg }));
}
